<template lang="pug">
v-sheet.py-16.px-2.px-sm-8.px-md-16.d-flex.align-center(
  color="primary lighten-5"
)
  v-container.my-md-16(fluid)
    v-row(justify="center" align="center")
      v-col(cols=12 md=6)
        h2.mb-8.mb-sm-12.mb-md-14.ibm.text-h4.text-md-h2.font-weight-regular.primary--text Quanto vai custar o meu Erudio?
        h5.mb-4.mb-md-6.heebo.text-body-1.text-sm-h6.text-md-h5.font-weight-regular.grey--text.text--darken-4 Selecione o seu plano e informe quantos alunos ativos você espera ter no Erudio e saiba quanto vai dar a sua fatura.
        h5.mb-4.mb-sm-0.heebo.text-body-1.text-sm-h6.text-md-h5.font-weight-regular.grey--text.text--darken-4 Nossa calculadora é inteligente e já aplica descontos para usos maiores!
      v-col(cols=12 md=6)
        v-card.calculator-card.pa-5(outlined)
          v-select(
            label="Selecione o plano"
            :items="plans"
            item-text="name"
            flat
            solo
            background-color="white"
            height=56
          )
          v-text-field(
            type="number"
            label="Informe o número de alunos"
            flat
            solo
            background-color="white"
            height=56
          )
          v-btn.mt-4.mt-md-8.px-md-16.heebo.text-body-1.font-weight-medium.text-none(
            color="primary"
            block
            depressed
            height=56
          ) Calcular!
          h4.mb-2.mb-sm-4.mb-md-6.mt-8.mt-sm-12.mt-md-14.ibm.text-h5.text-md-h4.grey--text.text--darken-4 Você vai investir:
          h2.ibm.text-h3.text-md-h2.font-weight-light.black--text R$ 0,00
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapState('page', ['plans'])
  }
}
</script>

<style lang="sass" scoped>
.calculator-card
  border: 1px solid var(--v-primary-base)
  border-radius: 12px
  background-color: #F7F7F7
</style>
